export default "__VITE_ASSET__d592ce9c__"